<template>
	<div class="full-width">
		<h6
			class="subheading mb-1"
			:class="{ 'text-ellipsis': !isFullView, 'black--text': isRepost }"
		>{{ getCaption(post) }}</h6>
		<h6 class="mb-0 pa-1 hashtag" :class="{ 'is-adult-tag': isAdultTag(post) }">{{ getHashtag(post) }}</h6>
	</div>
</template>

<script>
import * as utils from "@/utils.js";
const { ADULT_TAG_LIST } = utils;

export default {
	name: "AnalyticsElCaption",
	props: ["post", "isFullView", "isRepost"],
	methods: {
		getCaption(post) {
			return post.caption
				? post.caption.S
				: post.text && post.repostData
				? post.text.S
				: "";
		},
		isAdultTag(post) {
			return ADULT_TAG_LIST.indexOf(utils.getHashtagId(post)) !== -1;
		},
		getHashtag(post) {
			return utils.getHashtag(post);
		}
	}
};
</script>

<style lang="scss" scoped>
h3 {
	line-height: 1.4;
}
.hashtag {
	color: #bd0ebd;
	&.is-adult-tag {
		background-color: red;
		color: #fff;
	}
}
</style>
